const EventsSponsorship = () => {
  return (
  <>
    <div aria-hidden={true} aria-labelledby="exhibitorLabel" className="modal fade" id="eventsExhibitorModal" role="dialog" tabIndex={-1}>
      <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exhibitorLabel">Learn more about Exhibiting at RAPS Events.</h5>
            <button aria-label="Close" className="close" data-dismiss="modal" type="button"><span aria-hidden="true">&times;</span></button></div>

          <div className="modal-body">
            <div className="container-fluid">
              <form action="https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8" method="POST"><input name="oid" type="hidden" value="00Do0000000aIJN" /> <input name="retURL" type="hidden" value="https://www.raps.org/events?sponsorship=calendar" />
                <div className="form-row row">
                  <div className="col-md-6 offset-md-3 form-group"><label htmlFor="exhibitorVenue">RAPS Venue: &nbsp;</label> <select className="form-control" id="exhibitorVenue" name="lead_source" required style={{display: "inline-block", width: "60%"}}><option value="Convergence">Convergence</option><option value="EuroConvergence">Euro Convergence</option><option selected value="OtherRAPSEvents">Other RAPS Events</option></select></div>

                  <div className="form-group col-md-6"><label htmlFor="exhibitorFirst">First Name</label> <input className="form-control" id="exhibitorFirst" maxLength={40} name="first_name" required type="text" /></div>

                  <div className="form-group col-md-6"><label htmlFor="exhibitorLast">Last Name</label> <input className="form-control" id="exhibitorLast" maxLength={80} name="last_name" required type="text" /></div>

                  <div className="form-group col-md-6"><label htmlFor="exhibitorEmail">Email</label> <input className="form-control" id="exhibitorEmail" maxLength={80} name="email" required type="email" /></div>

                  <div className="form-group col-md-6"><label htmlFor="exhibitorTitle">Title</label> <input className="form-control" id="exhibitorTitle" maxLength={40} name="title" required type="text" /></div>

                  <div className="form-group col-md-6"><label htmlFor="exhibitorCompany">Company</label> <input className="form-control" id="exhibitorCompany" maxLength={40} name="company" required type="text" /></div>

                  <div className="form-group col-md-6"><label htmlFor="industry">Industry</label> <select className="form-control" id="industry" name="industry"><option value="">--None--</option><option value="Medical Devices">Medical Devices</option><option value="Pharmaceuticals">Pharmaceuticals</option><option value="Biopharmaceuticals">Biopharmaceuticals</option><option value="Biotechnology">Biotechnology</option><option value="Food &amp; Beverage">Food &amp; Beverage</option><option value="Nutrition">Nutrition</option><option value="Consulting">Consulting</option><option value="Government">Government</option><option value="Education">Education</option><option value="Other">Other</option> </select></div>
                </div>

                <div className="form-group">
                  <div className="form-check"><input className="form-check-input" id="exhibitorConsent" type="checkbox" /> <label className="form-check-label" htmlFor="exhibitorConsent"> I consent to receive e-mail communications from RAPS relating to RAPS Events. I understand that I may unsubscribe at any time by clicking the &quot;Unsubscribe&quot; link at the bottom of all e-mails or by <a href="mailto:raps@raps.org">e-mailing RAPS.</a> </label></div>
                </div>

                  <div className="float-right">
                    <button className="btn btn-outline-primary mr-4" data-dismiss="modal" type="button">Close</button> &nbsp; &nbsp;
                    <button className="btn btn-primary" disabled id="exhibitorSubmit" type="submit">Submit</button></div>
              </form>
            </div>
          </div>
        </div>
      </div>
     </div>
      <style>
        {`
              #eventsExhibitorModal.modal .form-control {
                display: block;
                width: 100%;
                padding: 0.375rem 0.75rem;
                font-size: 1rem;
                line-height: 1.5;
                color: #495057;
                background-color: #fff;
                background-clip: padding-box;
                border: 1px solid #ced4da;
                border-radius: 0.25rem;
                transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
              }
              #eventsExhibitorModal.modal  .form-control::-ms-expand {
                background-color: transparent;
                border: 0;
              }
              #eventsExhibitorModal.modal .form-control:focus {
                color: #495057;
                background-color: #fff;
                border-color: #9362d0;
                outline: 0;
                box-shadow: 0 0 0 0.2rem rgba(84, 41, 137, 0.25);
              }
              #eventsExhibitorModal.modal .form-control:-ms-input-placeholder {
                color: #ccc;
                opacity: 1;
              }
              #eventsExhibitorModal.modal .form-control::placeholder {
                color: #ccc;
                opacity: 1;
              }
              #eventsExhibitorModal.modal .form-control:disabled,
              #eventsExhibitorModal.modal .form-control[readonly] {
                background-color: #e9ecef;
                opacity: 1;
              }
              #eventsExhibitorModal.modal select.form-control:not([size]):not([multiple]) {
                height: calc(2.25rem + 2px);
              }
              #eventsExhibitorModal.modal select.form-control:focus::-ms-value {
                color: #495057;
                background-color: #fff;
              }
              #eventsExhibitorModal.modal .btn {
                padding: 0.375rem 0.75rem;
                border-radius: 0.25rem;
              }

              #eventsExhibitorModal .form-group {
                margin-bottom: 1rem;
              }
              #eventsExhibitorModal .form-text {
                display: block;
                margin-top: 0.25rem;
              }
              #eventsExhibitorModal .form-row {
                display: -ms-flexbox;
                display: flex;
                -ms-flex-wrap: wrap;
                flex-wrap: wrap;
                margin-right: -5px;
                margin-left: -5px;
              }
              #eventsExhibitorModal .form-row > .col,
              #eventsExhibitorModal .form-row > [class*="col-"] {
                padding-right: 5px;
                padding-left: 5px;
              }
              #eventsExhibitorModal .form-check {
                position: relative;
                display: block;
                padding-left: 1.25rem;
              }
              #eventsExhibitorModal .form-check-input {
                position: absolute;
                margin-top: 0.3rem;
                margin-left: -1.25rem;
              }
              #eventsExhibitorModal .form-check-input:disabled ~ .form-check-label {
                color: #ccc;
              }
              #eventsExhibitorModal .form-check-label {
                margin-bottom: 0;
              }


              #eventsExhibitorModal.fade {
                opacity: 0;
                transition: opacity 0.15s linear;
              }
              #eventsExhibitorModal.fade.show {
                opacity: 1;
              }

              #eventsExhibitorModal.modal-open {
                overflow: hidden;
              }
              #eventsExhibitorModal.modal {
                position: fixed;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                z-index: 1050;
                display: none;
                overflow: hidden;
                outline: 0;
              }
              #eventsExhibitorModal.modal-open .modal {
                overflow-x: hidden;
                overflow-y: auto;
              }
              #eventsExhibitorModal .modal-dialog {
                position: relative;
                width: auto;
                margin: 0.5rem;
                pointer-events: none;
              }
              #eventsExhibitorModal.modal.fade .modal-dialog {
                transition: transform 0.3s ease-out;
                transform: translate(0, -25%);
              }
              #eventsExhibitorModal.modal.show .modal-dialog {
                transform: translate(0, 0);
              }
              #eventsExhibitorModal .modal-dialog-centered {
                display: -ms-flexbox;
                display: flex;
                -ms-flex-align: center;
                align-items: center;
                min-height: calc(100% - (0.5rem * 2));
              }
              #eventsExhibitorModal .modal-content {
                position: relative;
                display: -ms-flexbox;
                display: flex;
                -ms-flex-direction: column;
                flex-direction: column;
                width: 100%;
                pointer-events: auto;
                background-color: #fff;
                background-clip: padding-box;
                border: 1px solid rgba(35, 31, 32, 0.2);
                border-radius: 0.3rem;
                outline: 0;
              }
              .modal-backdrop {
                position: fixed;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                z-index: 1040;
                background-color: #231f20;
              }
              .modal-backdrop.fade {
                opacity: 0;
              }
              .modal-backdrop.show {
                opacity: 0.5;
              }
              #eventsExhibitorModal .modal-header {
                display: -ms-flexbox;
                display: flex;
                -ms-flex-align: start;
                align-items: flex-start;
                -ms-flex-pack: justify;
                justify-content: space-between;
                padding: 1rem;
                border-bottom: 1px solid #e9ecef;
                border-top-left-radius: 0.3rem;
                border-top-right-radius: 0.3rem;
              }
              #eventsExhibitorModal .modal-header .close {
                padding: 1rem;
                margin: -1rem -1rem -1rem auto;
              }
              #eventsExhibitorModal .modal-title {
                margin-bottom: 0;
                line-height: 1.5;
              }
              #eventsExhibitorModal .modal-body {
                position: relative;
                -ms-flex: 1 1 auto;
                flex: 1 1 auto;
                padding: 1rem;
              }
              #eventsExhibitorModal .modal-footer {
                display: -ms-flexbox;
                display: flex;
                -ms-flex-align: center;
                align-items: center;
                -ms-flex-pack: end;
                justify-content: flex-end;
                padding: 1rem;
                border-top: 1px solid #e9ecef;
              }
              #eventsExhibitorModal .modal-footer > :not(:first-child) {
                margin-left: 0.25rem;
              }
              #eventsExhibitorModal .modal-footer > :not(:last-child) {
                margin-right: 0.25rem;
              }
              #eventsExhibitorModal .modal-scrollbar-measure {
                position: absolute;
                top: -9999px;
                width: 50px;
                height: 50px;
                overflow: scroll;
              }
              @media (min-width: 576px) {
                #eventsExhibitorModal .modal-dialog {
                  max-width: 500px;
                  margin: 1.75rem auto;
                }
                #eventsExhibitorModal .modal-dialog-centered {
                  min-height: calc(100% - (1.75rem * 2));
                }
                #eventsExhibitorModal .modal-sm {
                  max-width: 300px;
                }
              }
              @media (min-width: 992px) {
                #eventsExhibitorModal .modal-lg {
                  max-width: 800px;
                }
              }
              #eventsExhibitorModal .modal-content .form-check-input{
                margin-top: 0.3rem;
                margin-left: -1.25rem;
              }

              .btn-outline-primary {
                color: #262669;
                background-color: transparent;
                background-image: none;
                border-color: #262669;
              }
              .btn-outline-primary:hover {
                color: #fff;
                background-color: #262669;
                border-color: #262669;
              }
              .btn-outline-primary:focus,
              .btn-outline-primary.focus {
                box-shadow: 0 0 0 0.2rem rgba(84, 41, 137, 0.5);
              }
              .btn-outline-primary.disabled,
              .btn-outline-primary:disabled {
                color: #262669;
                background-color: transparent;
              }
              .btn-outline-primary:not(:disabled):not(.disabled):active,
              .btn-outline-primary:not(:disabled):not(.disabled).active,
              .show > .btn-outline-primary.dropdown-toggle {
                color: #fff;
                background-color: #262669;
                border-color: #262669;
              }
              .btn-outline-primary:not(:disabled):not(.disabled):active:focus,
              .btn-outline-primary:not(:disabled):not(.disabled).active:focus,
              .show > .btn-outline-primary.dropdown-toggle:focus {
                box-shadow: 0 0 0 0.2rem rgba(84, 41, 137, 0.5);
              }

          `}
      </style>
    </>
  );
}

export default EventsSponsorship;